require('./bootstrap');
import Vue from "vue";

import DisableAutocomplete from 'vue-disable-autocomplete';
import VueHtml2pdf from 'vue-html2pdf';
// import NoAutoComplete from 'vue-no-autocomplete';

// import NoAutoComplete from "vue-no-autocomplete";
// Vue.config.productionTip = false;

import Showpassword from './components/Auth/Showpassword.vue'
import Categories from './components/Categories.vue'
import Cameras from './components/Cameras.vue'
import Persons from './components/Persons/Persons.vue'
import PersonsList from './components/Persons/PersonsList.vue'
import Person from './components/Persons/Person.vue'
import Videos from './components/Videos.vue'
import Reports from './components/Reports.vue'
import Settings from './components/Settings.vue'
import Users from './components/Users.vue'
import Report from './components/Report.vue'
import Popup from './components/Popup.vue'
import Alert from './components/Alert.vue'
import Dotscontrol from './components/Dotscontrol.vue'
import back from './components/back.vue'
import backreports from './components/backreports.vue'

import SitebarHistorylog from './components/sitebar/Historylog.vue'
import Filters from './components/sitebar/Filters.vue'
import SitebarReports from './components/sitebar/Reports.vue'
import store from "./store";

const HelperPlugin = {}

HelperPlugin.install = function (Vue, options) {    
    Vue.getGmtObjFromUtc = function (date = null){        
        let gmtDateObj = {},
            hDate = date;
        gmtDateObj.Y = hDate.getUTCFullYear(),
        gmtDateObj.month = hDate.getUTCMonth()+1,
        gmtDateObj.d = hDate.getUTCDate(),
        gmtDateObj.h = hDate.getUTCHours(),
        gmtDateObj.minutes = hDate.getUTCMinutes(),
        gmtDateObj.s = hDate.getUTCSeconds();        
        if( gmtDateObj.month < 10) gmtDateObj.month = '0' + gmtDateObj.month;
        if( gmtDateObj.d < 10) gmtDateObj.d = '0' + gmtDateObj.d;
        if( gmtDateObj.h < 10) gmtDateObj.h = '0' + gmtDateObj.h;
        if( gmtDateObj.minutes < 10) gmtDateObj.minutes = '0' + gmtDateObj.minutes;
        if( gmtDateObj.s < 10) gmtDateObj.s = '0' + gmtDateObj.s;        
        return gmtDateObj;
    }
    Vue.getGmtObjFromStr = function (strDate = null){
        let gmtAr =  strDate.split(/[^0-9]/g),
            gmtDateObj = {};            
        gmtDateObj.Y = +gmtAr[0],
        gmtDateObj.month = +gmtAr[1],
        gmtDateObj.d = +gmtAr[2],
        gmtDateObj.h = +gmtAr[3],
        gmtDateObj.minutes = +gmtAr[4],
        gmtDateObj.s = +gmtAr[5];        
        return gmtDateObj;
    }
    Vue.getUtcFromGmtObj = function (gmtObj = null){
        const utcDate = Date.UTC(
            gmtObj.Y,
            --gmtObj.month,
            gmtObj.d,
            gmtObj.h,
            gmtObj.minutes,
            gmtObj.s
        );
        return utcDate;
    }
    Vue.getGmtStr = function (gmtObj = null){        
      return `${gmtObj.Y}-${gmtObj.month}-${gmtObj.d} ${gmtObj.h}:${gmtObj.minutes}:${gmtObj.s}`;
    },
    Vue.convertTimestamp = (timestamp) => {
        let d = new Date(timestamp * 1000);
        let yyyy = d.getUTCFullYear();
        let mm = ('0' + (d.getUTCMonth() + 1)).slice(-2);      
        let dd = ('0' + d.getUTCDate()).slice(-2);
        let hh = ('0' + d.getUTCHours()).slice(-2);
        let min = ('0' + d.getUTCMinutes()).slice(-2);
        let time = yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + min;            
        return time;
    }
}

global.hVue = Vue;
hVue.use(HelperPlugin);

Vue.use(DisableAutocomplete);
Vue.use(VueHtml2pdf);
// Vue.use(NoAutoComplete);

// Vue.use(NoAutoComplete);

const app = new Vue({
    el: '#app',
    store,    
    components:{
        Showpassword,
        Cameras,
        Categories,
        Alert,
        Popup,
        Dotscontrol,
        Persons,
        Person,
        Videos,
        Reports,
        Settings,
        Users,
        Report,
        back,
        backreports,
        SitebarHistorylog,
        Filters,
        SitebarReports,
        PersonsList,
        DisableAutocomplete,
        VueHtml2pdf
    },
    created() {
        store.dispatch('getBaseUrl');
    },    
});
